(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notificacao', {
            parent: 'entity',
            url: '/notificacao?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notificações do Usuário'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notificacao/notificacoes.html',
                    controller: 'NotificacaoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('notificacao-detail', {
            parent: 'notificacao',
            url: '/notificacao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notificação do Usuário'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notificacao/notificacao-detail.html',
                    controller: 'NotificacaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Notificacao', function($stateParams, Notificacao) {
                    return Notificacao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'notificacao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();
